/**
 * =========================================================================================
 * Activity Filter - Category tabs and type filter
 * =========================================================================================
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const CATEGORY_TABS = [
    { label: 'All', value: null },
    { label: 'My Actions', value: 'USER_ACTION' },
    { label: 'System Events', value: 'SYSTEM_EVENT' },
];

const ActivityFilter = () => {
    const dispatch = useDispatch();
    const _FILTER = useSelector(e => e?.filter?.billingActivity);

    const handleCategoryChange = (value) => {
        dispatch({
            type: 'SET_BILLING_ACTIVITY',
            payload: { category: value, skip: 0 }
        });
    };

    return (
        <div className="u_flex-align">
            <div className="u_flex-align u_bg-thead u_radius-8 u_p-4">
                {CATEGORY_TABS.map(tab => {
                    const isActive = _FILTER?.category === tab.value;
                    return (
                        <div
                            key={tab.label}
                            className={`u_px-14 u_py-6 u_radius-5 u_cp u_small-font u_fw-500 u_ws-nowrap ${
                                isActive
                                    ? 'u_bg-white u_color-blue u_b-light'
                                    : 'u_color-font'
                            }`}
                            onClick={() => handleCategoryChange(tab.value)}
                        >
                            {tab.label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ActivityFilter;
